import React from 'react';
import FormButton from 'src/components/button';
import {watchMedia, getMedia} from 'shared/mq';

class EmptyPlaceholder extends React.Component {
  UNSAFE_componentWillMount() {
    this.mq = watchMedia(() => {
      this.forceUpdate();
    });
  }

  componentWillUnmount() {
    this.mq.remove();
  }

  render() {
    const mq = getMedia();

    const headline = mq.MD_AND_UP
      ? 'Follow colleges to start earning.'
      : 'Follow colleges to start earning scholarships.';

    const description = "You'll only earn scholarships from the colleges you're following.";

    const buttonText = mq.MD_AND_UP ? 'Follow Colleges' : 'Follow';

    return (
      <div className="college-earnings-empty-placeholder">
        {mq.MD_AND_UP ? (
          <div className="college-earnings-empty-placeholder-image following-empty-state"></div>
        ) : null}
        <p className="college-earnings-empty-placeholder-headline">{headline}</p>
        {mq.MD_AND_UP ? (
          <p className="college-earnings-empty-placeholder-description">{description}</p>
        ) : null}
        <a href="/colleges">
          <FormButton color="primary" outline={mq.MD_AND_UP} type="button">
            {buttonText}
          </FormButton>
        </a>
      </div>
    );
  }
}

export default EmptyPlaceholder;
